import React, { useState, useEffect, useContext } from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { getDiffDays } from "../../../shared/utils/dateUtilities";
import { getComments } from "../../../services/tribe";
import Button from "../../atoms/button/button";
import CardCommentActivity from "../../atoms/card-comment-activity/cardCommentActivity";
import MakeComment from "../make-comment/makeComment";
import MobileCommentModal from "../../molecules/mobile-comment-modal/mobileCommentModal";
import ModalApprove from "../../atoms/modal-approve/modalApprove";

import "./commentsActivity.scss";
import GlobalContext from "../../../contexts/globalContext";

const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const CommentsActivity = (props: ReferenciaContenido) => {
  const { gigyaContext: { gigyaAccount } } = useContext(GlobalContext);
  const [lastIdx, setLastIdx] = useState<any>(5);
  const [newCommentModal, setNewCommentModal] = useState<any>(false);
  const [commentPublish, setCommentPublish] = useState<any>(false);
  const [userId, setUserId] = useState<any>(0);
  const [comments, setComments] = useState<any>([]);
  const [currentEditingId, setCurrentEditingId] = useState<any>(undefined);
  const [valueInput, setValueInput] = useState<any>(undefined);

  useEffect(() => {
    const getCommentsFn = async () => {
      const response: any = await getComments(
        props.autoresArticulo[0],
        gigyaAccount?.profile && gigyaAccount?.profile.email,
        gigyaAccount?.profile.firstName +
          " " +
          gigyaAccount?.profile.lastName || "",
        gigyaAccount?.UID || ""
      );
      setUserId(response.userId);
      let commentsRes = response.comments;
      let commentsArr = Array();
      for (let i = 0; i < response.comments.length; i++) {
        let comment = {
          imagenPrincipal: [
            {
              file: {
                url: commentsRes[i].user.profile.picture,
              },
            },
          ],
          name: commentsRes[i].user.profile.name,
          date: formatDate(commentsRes[i].createdAt),
          comment: commentsRes[i].content,
          data: { ...commentsRes[i] },
        };
        commentsArr.push(comment);
      }
      setComments(commentsArr);
    };
    getCommentsFn();
  }, [gigyaAccount?.UID]);

  const formatDate = (date: string) => {
    const today = new Date();
    const cd = date
      .split(" ")[0]
      .split("/")
      .map((cd) => parseInt(cd));
    const ct = date
      .split(" ")[1]
      .split(":")
      .map((ct) => parseInt(ct));
    const commentDate = new Date(cd[2], cd[1] - 1, cd[0], ct[0], ct[1], ct[1]);
    const daysDiff = getDiffDays(commentDate.toString(), today.toString());
    const hoursDiff = today.getHours() - commentDate.getHours();
    const minutesDiff = today.getMinutes() - commentDate.getMinutes();
    if (daysDiff > 7) {
      return cd[0] + " " + MONTHS[cd[1] - 1] + " " + cd[2];
    } else if (daysDiff > 0) {
      return daysDiff > 1 ? "Hace " + daysDiff + " días" : "Ayer";
    } else if (hoursDiff > 0) {
      return "Hace " + hoursDiff + (hoursDiff > 1 ? " horas" : " hora");
    } else if (minutesDiff > 0) {
      return "Hace " + minutesDiff + (minutesDiff > 1 ? " minutos" : " minuto");
    } else {
      return "Hace menos de 1 minuto";
    }
  };

  return (
    <div className="m-comments-activity">
      {newCommentModal && (
        <MobileCommentModal
          closeModal={() => setNewCommentModal(false)}
          closeModalPublish={() => {
            setNewCommentModal(false);
            setCommentPublish(true);
            setCurrentEditingId(undefined);
          }}
          urlImage={null}
          idConversation={props.autoresArticulo[0]}
          updatingComment={currentEditingId}
          valueInput={valueInput ? valueInput : undefined}
        />
      )}
      <ModalApprove
        onClose={() => {
          setCommentPublish(false);
          window.location.reload();
        }}
        open={commentPublish}
      />
      <h2 className="m-comments-activity__title">{props.tituloGeneral}</h2>
      <div className="m-comments-activity__comment">
        <MakeComment showTitle={false} referenciaContenido={props} />
      </div>

      <div className="m-comments-activity__comments">
        {comments.slice(0, lastIdx).map((comment, idx) => {
          return (
            <CardCommentActivity
              comment={comment}
              key={idx}
              userId={userId}
              handleNewCommentModal={setNewCommentModal}
              setCurrentId={setCurrentEditingId}
              setValueInput={setValueInput}
            />
          );
        })}
      </div>
      {lastIdx < comments.length && (
        <div className="m-comments-activity__more">
          <Button
            text="VER MÁS"
            isDisabled={false}
            classname="m-comments-activity__more-btn"
            type="button"
            onClickAction={() => {
              setLastIdx(lastIdx + 5);
            }}
          />
        </div>
      )}
    </div>
  );
};
export default CommentsActivity;
